import { useEffect, useRef, useState } from "react";
import "./CaptionProfileMenu.scss";

const getInitials = (name, email) => {
  const trimmed = (name || "").trim();

  if (trimmed) {
    const parts = trimmed.split(/\s+/).filter(Boolean);

    if (parts.length >= 2) {
      return `${parts[0][0] || ""}${parts[parts.length - 1][0] || ""}`.toUpperCase();
    }

    return trimmed.slice(0, 2).toUpperCase();
  }

  if (email) {
    return email.slice(0, 2).toUpperCase();
  }

  return "?";
};

const CaptionProfileMenu = ({ user, isLoggedIn, onSignInRequest, onLogout }) => {
  const menuRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const handleToggle = () => {
    if (!isLoggedIn) {
      onSignInRequest();
      return;
    }

    setIsOpen((open) => !open);
  };

  const handleLogout = () => {
    setIsOpen(false);
    onLogout();
  };

  const displayName = user?.name || user?.email || "Account";
  const initials = getInitials(user?.name, user?.email);

  return (
    <div className="caption-profile-menu" ref={menuRef}>
      <button
        type="button"
        className="caption-profile-menu__trigger"
        onClick={handleToggle}
        aria-label={isLoggedIn ? "Open account menu" : "Sign in with Google"}
        aria-expanded={isLoggedIn ? isOpen : false}
        aria-haspopup={isLoggedIn ? "menu" : undefined}
      >
        {isLoggedIn && user?.pictureUrl ? (
          <img
            src={user.pictureUrl}
            alt={displayName}
            className="caption-profile-menu__photo"
          />
        ) : (
          <span className="caption-profile-menu__initials" aria-hidden="true">
            {isLoggedIn ? initials : "?"}
          </span>
        )}
      </button>

      {isLoggedIn && isOpen && (
        <div className="caption-profile-menu__dropdown" role="menu">
          <div className="caption-profile-menu__name" role="menuitem">
            {displayName}
          </div>
          <button
            type="button"
            className="caption-profile-menu__logout"
            role="menuitem"
            onClick={handleLogout}
          >
            Sign out
          </button>
        </div>
      )}
    </div>
  );
};

export default CaptionProfileMenu;
